import React, { type ReactElement, useMemo } from 'react';
import {
  Colors,
  Flex,
  Spinner,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import { CouponBackground } from './CouponBackground';
import { isWeb } from 'shared/src/utils';

export const WEB_NOT_MOBILE_WIDTH = 568;

export const CouponView: React.FC<{
  title: string;
  icon: ReactElement<{ width: number; height: number; fill: string }>;
  disabled?: boolean;
  onPress: () => void;
  loading?: boolean;
}> = props => {
  const { width } = useScreenSize();

  const size = useMemo(() => {
    const contentWidth = width - 30; // padding 16 + 16
    if (isWeb) {
      if (width > WEB_NOT_MOBILE_WIDTH) {
        return {
          width: contentWidth,
          height: contentWidth * (48 / 568),
        };
      }
    }
    return {
      width: contentWidth,
      height: contentWidth * (48 / 343),
    };
  }, [width]);

  return (
    <Flex onPress={props.onPress} testID={'쿠폰받기버튼'}>
      <Flex position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <CouponBackground
          width={size.width}
          height={size.height}
          disabled={props.disabled}
        />
      </Flex>

      <Flex.Row width={size.width} height={size.height}>
        <Flex flex={1} padding={{ horizontal: 16 }} justifyContent={'center'}>
          <Typography
            type={'subtitle2'}
            color={props.disabled ? 'content_disabled' : 'content_blue_primary'}
          >
            {props.title}
          </Typography>
        </Flex>
        <Flex alignItems={'center'} justifyContent={'center'}>
          <Flex
            borderWidth={0.5}
            borderColor={'border_blue_secondary'}
            height={16}
          ></Flex>
        </Flex>
        <Flex
          width={size.height}
          height={size.height}
          alignItems={'center'}
          justifyContent={'center'}
        >
          {React.cloneElement(props.icon, {
            fill: props.disabled
              ? Colors.bg_black_button
              : Colors.content_blue_primary,
          })}
        </Flex>
      </Flex.Row>
      {props.loading && (
        <Flex
          position={'absolute'}
          top={0}
          left={0}
          right={0}
          bottom={0}
          alignItems={'center'}
          justifyContent={'center'}
          backgroundColor={'white'}
          backgroundColorOpacity={0.4}
        >
          <Spinner color={'content_blue_primary'} size={24} />
        </Flex>
      )}
    </Flex>
  );
};
